import { render, staticRenderFns } from "./ImageSlider.vue?vue&type=template&id=2c0cd660&"
import script from "./ImageSlider.vue?vue&type=script&lang=js&"
export * from "./ImageSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports